export default __webpack_public_path__ + "static/media/mcgill-university.c3802cf5.png";